import { useCallback, useEffect, useState } from "react";
import { getCJWUploadHistory } from "../../API/CJWUploadHistoryApi";
import { getCJWDIUploadHistory } from "../../API/CJWDIUploadHistoryApi";

export const useUploadHistoryDelete = (isDIMode = false) => {
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchUploadHistoryDelete = useCallback(async () => {
        try{
            const data = isDIMode ? await getCJWDIUploadHistory() : await getCJWUploadHistory();
            if(data){
                return data;
            }
        } catch (error) {
            console.error("Error fetching upload history:", error);
        } finally {
            setLoading(false);
        }
    }, [isDIMode]);

    useEffect(() => {
        fetchUploadHistoryDelete();
    }, [fetchUploadHistoryDelete]);

    return {
        fetchUploadHistoryDelete,
        page,
        setPage,
        loading,
    };
};
